module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp13_6000.9847fa55.png";